module.exports = __webpack_public_path__ + "img/ai_help01_img_02.4f475292.png";